module.exports = __webpack_public_path__ + "static/img/book5.9c825f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book5.jpg
// module id = PCGa
// module chunks = 1